import type { FileMetadata, GetFileMetadataRequest, GetSingleFileUrlRequest } from "@somewear/api";

export interface FileMetadataWithState extends FileMetadata.AsObject {
	state: FileState;
	requestId?: string;
	file?: File;
}

export enum FileState {
	Pending = "pending",
	Error = "error",
	Success = "success",
}

export interface UploadFileRequest {
	senderId: string;
	workspaceId: string;
	file: File;
}

export type UploadFileResponse = {
	signedUploadUrl: string;
	fileMetadata: FileMetadata.AsObject;
};

export type GetConversationFilesResponse = FileMetadata.AsObject[];

export interface GetConversationFilesRequestPayload {
	workspaceId?: GetFileMetadataRequest.AsObject["workspaceId"];
	conversationId?: GetFileMetadataRequest.AsObject["conversationId"];
}

export interface DownloadFileRequestPayload {
	fileId: string;
	workspaceId?: GetSingleFileUrlRequest.AsObject["workspaceId"];
	conversationId?: GetSingleFileUrlRequest.AsObject["conversationId"];
}

export type DownloadFileResponse = string;
